import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import { StringKeyDictionary } from "../../../commonInterfaces";
import React from "react";
export default class ProcedureArticleDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};


    componentDidMount() {
        Helper.getTranslations(["Field.Material.artikelnummer", "Field.Material.produkt", "Field.Material.bezeichnung", "Field.Material.seriennummer", "Field.Material.chargennummer"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        const data = this.props.data;
        return (
            <PanelbarStructure label={data.Bezeichnung} keyPropValue={data.Bezeichnung}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Field.Material.artikelnummer"]}</span>
                            </td>
                            <td>
                                <span>{data.Artikelnummer}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Field.Material.produkt"]}</span>
                            </td>
                            <td>
                                <span>{data.Produkt}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Field.Material.bezeichnung"]}</span>
                            </td>
                            <td>
                                <span>{data.Bezeichnung}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Field.Material.seriennummer"]}</span>
                            </td>
                            <td>
                                <span>{data.SerienNr}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Field.Material.chargennummer"]}</span>
                            </td>
                            <td>
                                <span>{data.ChargenNr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}
